export const config = {
	"mainnet": {
		"derps": {
			"abi": require("./abis/derps.json"),
			"address": "0x8500d84b203775FC8B418148223872b35c43B050"
		},
		"derp": {
			"abi": require("./abis/derp.json"),
			"address": "0xe920d1DA9A4D59126dC35996Ea242d60EFca1304"
		},
		"derper": {
			"abi": require("./abis/derper.json"),
			"address": "0x271E06105AC0eB492d58258Ac1130Ea5564Afa46"
		},
		"treasury": {
			"address": "0x68705637c16bF32A28a82914f7aADEFB3aBE31CD"
		},
		"derpPromoItems": {
			"abi": require("./abis/promoItems.json"),
			"address": "0xc7B2C6CF2Ed40e4514B48a71e3aa0D56a2b14427"
		},
		"derpSnacks": {
			"abi": require("./abis/derpSnacks.json"),
			"address": "0xfd20ebEB1c991983B056f1a6aDd5F3dea3cD52E8"
		}

	},
	"testnet": {
		"derps": {
			"abi": require("./abis/derps.json"),
			"address": "0xf7DDC89c07C5e1E8cE8BA3821321543045e19e9c"
		},
		"derp": {
			"abi": require("./abis/derp.json"),
			"address": "0x5fc63611E508879dDD5bdde0782Df0f2E543B172"
		},
		"derper": {
			"abi": require("./abis/derper.json"),
			"address": "0xFc8109734C93543ae601D8876D1280fa6e2704C4"
			//0x80d70BA931a3708aBb4e54492b18300Cf5F32E72
		},
		"treasury": {
			"address": "0xe02237ac085146389e8aCA2E501394bBa75A58e8"
		},
		"derpPromoItems": {
			"abi": require("./abis/promoItems.json"),
			"address": "0x33dF939c84AE702Fd25968B4BD98b943982DA8D4"
		},
		"derpSnacks": {
			"abi": require("./abis/derpSnacks.json"),
			"address": "0x97df8Dcb4306A7593b469CC87ef94ECA0437Eb79"
		}
	}
}


export const shop = {
	"event1": {
		"101": {
			"name": "Derpmander",
			"img": require("./imgs/derpmanderTRANS.PNG"),
			"cost": 69
		}, 
		"102": {
			"name": "Derptle",
			"img": require("./imgs/derptleTRANS.PNG"),
			"cost": 69	
		},
		"103": {
			"name": "Peekuhdewd",
			"img": require("./imgs/peekuhdewdTRANS.PNG"),
			"cost": 69	
		},
		"104": {
			"name": "Da Misssooor",
			"img": require("./imgs/misssooorTRANS.PNG"),
			"cost": 420	
		},
		"105": {
			"name": "Da Button",
			"img": require("./imgs/button.PNG")	
		}
	},
	"event2": {
		"106": {
			"name": "Moar",
			"img": require("./imgs/moar.png"),
			"cost": 69
		}, 
		"107": {
			"name": "Derp Vaydar",
			"img": require("./imgs/derpvaydur.png"),
			"cost": 420	
		},
		"108": {
			"name": "Yo Duh",
			"img": require("./imgs/yoduh.png"),
			"cost": 420	
		},
		"109": {
			"name": "Derp Star",
			"img": require("./imgs/derpstar.png")
		},
		"10001": {
			"name": "Derp Wars Poster",
			"img": require("./imgs/derpwarsposter-noback-s.png"),
			"cost": 100	
		}
	}
	}


	export const snacks = {
		"1": {
			"name": "Derper's Chips",
			"img": require("./imgs/snack_derpers-chips-og.png"),
			"cost": 250
		},
		"2": {
			"name": "Derpe Bar",
			"img": require("./imgs/snack_chocolate-bar.png"),
			"cost": 300
		},
		"3": {
			"name": "Derper's Hot Chips",
			"img": require("./imgs/snack_derpers-chips.png"),
			"cost": 250
		},
		"4": {
			"name": "Derp Cola",
			"img": require("./imgs/snack_derp-cola.PNG"),
			"cost": 200
		},
		"5": {
			"name": "Derp energy",
			"img": require("./imgs/snack_derp-energy.png"),
			"cost": 350
		},
	}
